/* Home finder.
   Go is an <a>. disabled is not a property of anchors, and
   .button[aria-disabled='true'] (base.css) keeps the control grey.
   The link is enabled only by setting href and removing aria-disabled. */
(function () {
  var LONG_LABEL_WORDS = 7;

  function shortLabel(text) {
    var words = String(text || '').split(' ');
    if (words.length > LONG_LABEL_WORDS) return words.slice(0, LONG_LABEL_WORDS).join(' ') + '...';
    return String(text || '');
  }

  function safeUrl(url) {
    if (typeof url !== 'string') return '';
    var trimmed = url.trim();
    if (trimmed.charAt(0) === '/' && trimmed.charAt(1) !== '/') return trimmed;
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return '';
  }

  function targetUrl(menu, main, sub, size) {
    if (!menu || !main || !sub || !size) return '';
    var group = menu[main];
    if (!group) return '';
    var options = group[sub];
    if (!options || !options.length) return '';
    for (var i = 0; i < options.length; i++) {
      if (options[i] && options[i].value === size) return safeUrl(options[i].value);
    }
    return '';
  }

  function goState(url) {
    if (url) return { href: url, enabled: true };
    return { href: null, enabled: false };
  }

  function applyGoState(link, state) {
    if (!link || !state) return;
    link.removeAttribute('disabled');
    if (state.enabled && state.href) {
      link.setAttribute('href', state.href);
      link.removeAttribute('aria-disabled');
      link.removeAttribute('role');
      link.removeAttribute('tabindex');
      return;
    }
    link.removeAttribute('href');
    link.setAttribute('aria-disabled', 'true');
    link.setAttribute('role', 'link');
    link.setAttribute('tabindex', '-1');
  }

  function clear(select) {
    while (select.firstChild) select.removeChild(select.firstChild);
  }

  function addOption(select, value, text) {
    var option = document.createElement('option');
    option.value = value;
    option.textContent = text;
    select.appendChild(option);
  }

  function fill(select, entries, placeholder) {
    clear(select);
    addOption(select, '', placeholder || '');
    for (var i = 0; i < entries.length; i++) {
      addOption(select, entries[i].value, shortLabel(entries[i].text));
    }
    select.value = '';
  }

  function watchFocus(select) {
    var wrapper = select.closest('.range_select_wrapper');
    if (!wrapper) return;
    select.addEventListener('focus', function () {
      wrapper.classList.add('focused');
    });
    select.addEventListener('blur', function () {
      wrapper.classList.remove('focused');
    });
  }

  function bind(root, menu) {
    var main = root.querySelector('[data-home-finder-main]');
    var sub = root.querySelector('[data-home-finder-sub]');
    var size = root.querySelector('[data-home-finder-size]');
    var go = root.querySelector('[data-home-finder-go]');
    if (!main || !sub || !size || !go) return false;

    function sync() {
      applyGoState(go, goState(targetUrl(menu, main.value, sub.value, size.value)));
    }

    function resetSize() {
      fill(size, [], size.getAttribute('data-placeholder'));
      size.disabled = true;
    }

    function onMain() {
      var group = menu[main.value] || {};
      var keys = Object.keys(group);
      var entries = [];
      for (var i = 0; i < keys.length; i++) entries.push({ value: keys[i], text: keys[i] });
      fill(sub, entries, sub.getAttribute('data-placeholder'));
      sub.disabled = entries.length === 0;
      resetSize();
      sync();
    }

    function onSub() {
      var group = (menu[main.value] || {})[sub.value] || [];
      var entries = [];
      for (var i = 0; i < group.length; i++) {
        entries.push({ value: group[i].value, text: group[i].text });
      }
      fill(size, entries, size.getAttribute('data-placeholder'));
      size.disabled = !sub.value || entries.length === 0;
      sync();
    }

    var equipment = Object.keys(menu);
    var equipmentEntries = [];
    for (var e = 0; e < equipment.length; e++) {
      equipmentEntries.push({ value: equipment[e], text: equipment[e] });
    }
    fill(main, equipmentEntries, main.getAttribute('data-placeholder'));

    main.addEventListener('change', onMain);
    sub.addEventListener('change', onSub);
    size.addEventListener('change', sync);
    size.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      if (go.getAttribute('aria-disabled') === 'true' || !go.getAttribute('href')) return;
      event.preventDefault();
      go.click();
    });
    go.addEventListener('click', function (event) {
      if (go.getAttribute('aria-disabled') === 'true' || !go.getAttribute('href')) event.preventDefault();
    });

    watchFocus(main);
    watchFocus(sub);
    watchFocus(size);
    sync();
    return true;
  }

  function readMenu(root) {
    var node = root.querySelector('[data-home-finder-menu]');
    if (!node) return null;
    try {
      var menu = JSON.parse(node.textContent);
      if (!menu || typeof menu !== 'object' || Array.isArray(menu)) return null;
      return menu;
    } catch (error) {
      console.error('Home finder menu is not valid JSON', error);
      return null;
    }
  }

  function mount(root) {
    if (!root || root.getAttribute('data-home-finder-bound') === 'true') return;
    var menu = readMenu(root);
    if (!menu) return;
    if (!bind(root, menu)) return;
    root.setAttribute('data-home-finder-bound', 'true');
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('[data-home-finder]');
    for (var i = 0; i < nodes.length; i++) mount(nodes[i]);
  }

  var api = {
    shortLabel: shortLabel,
    safeUrl: safeUrl,
    targetUrl: targetUrl,
    goState: goState,
    applyGoState: applyGoState,
    bind: bind,
    init: init
  };

  if (typeof window !== 'undefined') window.HomeFinder = api;

  function boot() {
    init(document);
  }

  if (typeof document === 'undefined') return;
  if (window.__homeFinderBooted) {
    if (document.readyState !== 'loading') boot();
    return;
  }
  window.__homeFinderBooted = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
